import { Injectable } from '@angular/core';
import { HttpService } from '../http/http.service';
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class CategoriesService {

  categoryList : BehaviorSubject<any[]> = new BehaviorSubject([]);
  constructor(private http: HttpService) {

   }

  getList(id_store:string){
    return this.http.get(`categories/${id_store}/list?counter=1`)
  }

  getMaterialsList() : Promise<any> {
    return this.http.get(`materials/list`)
  }

  setCategoriesList(list:any[]) {
    this.categoryList.next(list)
  }
  getCategoriesList(): Observable<any>{
    return this.categoryList
  }

  getThemesList() : Promise<any> {
    return this.http.get(`themes/list`)
  }

}
